import React from 'react';

import { SvgIconOwnProps } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import classes from './CheckCirleLabel.module.scss';

type CheckCircleLabelProps = {
  children: React.ReactNode;
  color?: SvgIconOwnProps['color'];
};

const CheckCircleLabel = ({ children, color = 'success' }: CheckCircleLabelProps) => {
  return (
    <div className={classes.titleLabel}>
      <CheckCircleRoundedIcon color={color} fontSize="large" />
      {children}
    </div>
  );
};

export { CheckCircleLabel };
